module.exports = __webpack_public_path__ + "static/media/three-dots-dark.4d469c70.svg";